import { lazy } from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

import { ViewTypeProvider } from '@/modules/shared/contexts/view-type/ViewTypeProvider'
import AppLayout from '@/modules/shared/layouts/app-layout/AppLayout'
import NotFound from '@/modules/shared/pages/not-found/NotFound'
import { ViewType } from '@/modules/shared/types/ViewType'

// Inside app layout
const MySupplierRoutes = lazy(() => import('@/routes/shared-routes/MySupplierRoutes'))
const InvoiceRoutes = lazy(() => import('@/routes/shared-routes/InvoiceRoutes'))
const StatementRoutes = lazy(() => import('@/routes/shared-routes/StatementRoutes'))
const ProductRoutes = lazy(() => import('@/routes/shared-routes/ProductRoutes'))
const ReportRoutes = lazy(() => import('@/routes/shared-routes/ReportRoutes'))
const UserRoutes = lazy(() => import('@/routes/shared-routes/UserRoutes'))
const SystemSettingsRoutes = lazy(() => import('@/routes/shared-routes/SystemSettingsRoutes'))
const BarcodeRoutes = lazy(() => import('@/routes/shared-routes/BarcodeRoutes'))
const MyAccountRoutes = lazy(() => import('@/routes/shared-routes/MyAccountRoutes'))
const CreditNoteRoutes = lazy(() => import('@/routes/shared-routes/CreditNoteRoutes'))
const SupplierDirectoryRoutes = lazy(() => import('@/routes/shared-routes/SupplierRoutes'))
const UtilityRoutes = lazy(() => import('@/routes/shared-routes/UtilityRoutes'))
const ShopRoutes = lazy(() => import('@/routes/public-routes/ShopRoutes'))
const PaperlessDashboard = lazy(() => import('@/modules/purchasing/pages/dashboard/PaperlessDashboard'))
const ScanningTaskRoutes = lazy(() => import('@/routes/shared-routes/ScanningTaskRoutes'))
const PaperlessEmailRoutes = lazy(() => import('@/routes/shared-routes/PaperlessEmailRoutes'))

function PurchaserContext() {
  return (
    <ViewTypeProvider viewType={ViewType.Purchaser}>
      <Outlet />
    </ViewTypeProvider>
  )
}

export default function PaperlessRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" />} />

      <Route element={<AppLayout />}>
        <Route element={<PurchaserContext />}>
          <Route path="/dashboard" element={<PaperlessDashboard />} />
          <Route path="/paperless-emails/*" element={<PaperlessEmailRoutes />} />
          <Route path="/scanning-tasks/*" element={<ScanningTaskRoutes />} />
          <Route path="/invoices/*" element={<InvoiceRoutes />} />
          <Route path="/statements/*" element={<StatementRoutes />} />
          <Route path="/credit-notes/*" element={<CreditNoteRoutes />} />
          <Route path="/my-suppliers/*" element={<MySupplierRoutes />} />
          <Route path="/supplier-directory/*" element={<SupplierDirectoryRoutes />} />
          <Route path="/products/*" element={<ProductRoutes />} />
          <Route path="/my-suppliers" element={<MySupplierRoutes />} />
          <Route path="/reports/*" element={<ReportRoutes />} />
          <Route path="/users/*" element={<UserRoutes />} />
          <Route path="/settings/*" element={<SystemSettingsRoutes />} />
          <Route path="/barcodes/*" element={<BarcodeRoutes />} />
          <Route path="/my-account/*" element={<MyAccountRoutes />} />
        </Route>
        <Route path="/utilities/*" element={<UtilityRoutes />} />
        <Route path="/shop/*" element={<ShopRoutes />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
